import { Paging } from 'app/module/global/Paging';
import { TextScramble } from 'utils/TextScramble';
import { HomePagingDeps } from './home.types';

/**
 * Paging side of the home section: the Paging module interop, the
 * progress-driven show/hide of the paging strip and the paging-title
 * scramble.
 */
export class HomePaging {
	private _deps: HomePagingDeps;

	private _paging: Paging;
	private _pagingIsShowing: boolean = false;

	//The #home-paging title scramble (moved from the HomeTimeline
	//constructor). Construction only — deliberately unwired: nothing calls
	//setText on it (TextScramble's DOM-redraw effects are kept off
	//frame-critical paths), and TextScramble's constructor is side-effect
	//free, so construction timing is inert:
	private _titleScramble: TextScramble;

	constructor(deps: HomePagingDeps) {
		this._deps = deps;
	}

	//Paging module delegation
	//-------------------------------------------------------------------------------------

	/**
	 * Setup paging.
	 * @param existingModule - the auto-created 'home-paging' module when the section is active, null otherwise
	 * @param container - the section container to manually create the module in
	 */
	public setup(existingModule: Paging, container: Element): void {
		//Title scramble (setup can re-run via modulesMounted, so create once):
		if (!this._titleScramble) {
			let pagingCopy: HTMLElement = document.querySelector('#home-paging .ui__paging__title');
			this._titleScramble = new TextScramble(pagingCopy, 15);
		}

		//If active then paging module is already auto crated on the page:
		if (existingModule) {
			this._paging = existingModule;
			this._paging.setCallbacks((index: number) => this._deps.onPagingClick(index));
			return;
		}

		//Otherwise manually create:
		this._paging = new Paging();
		this._paging.setContainer(container.querySelector('.ui__paging__home'));
		this._paging.id = 'home-paging';
		this._paging.create();
		this._paging.config.activeIndex = 0;
		this._paging.setCallbacks((index: number) => this._deps.onPagingClick(index));
	}

	public setActiveIndex(index: number): void {
		this._paging.setActiveIndex(index);
	}

	public showTitle(delay: number = 0): void {
		this._paging.showTitle(delay);
	}

	public showFromWork(): void {
		this._paging.showFromWork();
	}

	//Progress-driven show/hide
	//-------------------------------------------------------------------------------------

	public processShowHide(progressX: number): void {
		if (this._pagingIsShowing && progressX < 0.2) {
			this._pagingIsShowing = false;
			this._paging.hide();
			this._paging.setActiveIndex(0);
			console.log('HIDE PAGING');
		} else if (!this._pagingIsShowing && progressX > 0.2) {
			this._pagingIsShowing = true;
			this._paging.show();
			console.log('SHOW PAGING');
		}
	}
}
